<template>
  <div class="mb-5 mt-5 title-page">
    <b-col cols="12" class="title">
      <p class="pl-3 pr-3"><slot name="title"></slot></p>
    </b-col>
    <b-col cols="12" class="center subtitle mt-4">
      <p><slot name="subtitle"></slot></p>
    </b-col>
  </div>

</template>

<script>
export default {
  name: "v-main-title",
  props: {},
  data() {
    return {};
  },

  components: {},
};
</script>

<style lang="scss" scoped>
.title {
  text-transform: uppercase;
  border-bottom: 1px solid #fe5e00;
  height: 19px;
  text-align: center;
}

.title p {
  background-color: #fff;
  text-align: center;
  font-size: 25px;
  display: initial;
  color: #575757;
  font-weight: bold;
}
.subtitle p {
  text-align: center;
  font-size: 14px;
  color: #575757;
  text-transform: uppercase;
}
</style>
